"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistanceUnit = void 0;
var DistanceUnit;
(function (DistanceUnit) {
    DistanceUnit[DistanceUnit["Kilometers"] = 0] = "Kilometers";
    DistanceUnit[DistanceUnit["Miles"] = 1] = "Miles";
})(DistanceUnit || (exports.DistanceUnit = DistanceUnit = {}));
//# sourceMappingURL=DistanceUnit.js.map